module.exports = __webpack_public_path__ + "static/media/pr.b013635d.svg";